import { render, staticRenderFns } from "./ConfirmEmailAddress.vue?vue&type=template&id=4506fcb3&scoped=true&lang=pug&"
import script from "./ConfirmEmailAddress.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmailAddress.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmailAddress.vue?vue&type=style&index=0&id=4506fcb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4506fcb3",
  null
  
)

export default component.exports